<template>
    <section class="">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     @edit="handleEdit"
                     @review="handleReview"
                     btn_review
                     :btn_add="false"
                     :btn_edit="false"
        >
            <calendar-picker-filter :value="search.date_range" @change="handleCalendarChange" class="pull-right"></calendar-picker-filter>
        </front-table>

        <div class="clearfix"></div>

        <meeting-view :view_mode="view_mode" :single="single"
                      :btn_start_meeting = "false"
                      @cancel="view_mode = false">
        </meeting-view>

    </section>
</template>

<script>
    import FrontTable from "../components/front-table";
    import FrontMixins from "../common/mixins/front-mixins";
    import MeetingView from "../components/meeting-view";
    import CalendarPickerFilter from "@/components/calendar-picker-filter";

    export default {
        mixins: [FrontMixins],
        name: 'meeting-list',
        components: {CalendarPickerFilter, FrontTable,MeetingView},
        data() {
            return {
                dialogFormVisible: false
            }
        },
        created() {
            this.model = 'Admin.Meeting';

        },
        methods: {
        }
    }
</script>

<style scoped>

</style>
